<template>
  <vs-table :data="data">
    <template slot="header">
      <div class="con-input-search vs-table--search">
        <input
          class="input-search vs-table--search-input"
          type="text"
          v-model="text"
          @keypress.enter="search"
        />
        <vs-icon icon="search"></vs-icon>
      </div>
      <vs-button
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-filter"
        class="mx-2"
        radius
        @click="openFilter"
      ></vs-button>
    </template>
    <template slot="thead">
      <vs-th>
        {{ $t('vendor') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('rfc') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('active') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('status') | capitalize }}
      </vs-th>
      <th class="qb-sticky">
      </th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          <!-- <color-icon :color="'#fe3d3d'" /> -->
          {{ data[i].name | capitalize }}
        </vs-td>
        <vs-td>
          {{ data[i].rfc | upperCase }}
        </vs-td>
        <vs-td>
            <vs-switch success v-model="data[i].repse_active"  @input="updateStatus(data[i])"/>
        </vs-td>
        <vs-td>
          <vs-chip :color="data[i].status_color">
            {{  $t(data[i].status_name) | upperCase }}
          </vs-chip>
        </vs-td>
        <vs-td>
          <div>
            <action-icon
              icon="ArrowRightCircleIcon"
              :tooltip="$t('details')"
              @click="details(data[i])"
            />
          </div>
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
  
  <script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ColorIcon from '@/views/qb-components/ColorIcon'
import mixins from '@/mixins'
import ThSort from '@/views/components/ThSort'
export default {
  components: {
    ActionIcon,
    ColorIcon,
    ThSort,
  },
  data() {
    return {
      text: '',
      validate:false
    }
  },
  methods: {
    handleClickSort: function (e) {
      this.$emit('sort', e)
    },
    infiniteHandler: function (isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    openFilter: function () {
      this.$emit('openFilter', this.text)
    },
    search: function () {
      this.$emit('search', this.text)
    },
    details: function (item) {
      this.$emit('details',item.vendor_id)
    },
    updateStatus: function (item) {
      this.$emit('updateStatus',{id:item.vendor_id,status:item.repse_active})
    },
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
  
  <style>
</style>
  